export default __webpack_public_path__ + "9a49160636952159d13a3c72e467364f.svg";